/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Benchmark_DescInputs */

const en_mk_nav_benchmark_desc = /** @type {(inputs: Mk_Nav_Benchmark_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore the measurement method and results.`)
};

const id_mk_nav_benchmark_desc = /** @type {(inputs: Mk_Nav_Benchmark_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat metode dan hasil pengukuran.`)
};

/**
* | output |
* | --- |
* | "Explore the measurement method and results." |
*
* @param {Mk_Nav_Benchmark_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_benchmark_desc = /** @type {((inputs?: Mk_Nav_Benchmark_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Benchmark_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_benchmark_desc(inputs)
	return en_mk_nav_benchmark_desc(inputs)
});